var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',[_c('GnbLeftView'),_c('div',{attrs:{"id":"outer-wrap"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }